import React, {Component} from 'react';
import styled from 'styled-components';
import Translation from "../dictionary/Translation";
import bg from '../../img/Landscape-Footer.jpg'
import {mixins} from "../../mixins";
import H from "../typography/H";
import {presets} from "../../presets";
import Button from "../common/Button";

const Background = styled.div`
  background-image: url(${bg});
  ${mixins.stretch()};;
`;

const Content = styled.div`
  position: relative;
  text-align: center;
  color: ${p => p.theme.cWhite};
`;

const Header = styled.div`
  margin-bottom: 10px;
`;

const Subheader = styled.div`
  ${presets.h3()};
`;

const HeaderBlock = styled.div`
  margin-bottom: 20px;
`;

const Actions = styled.div`
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  >*{
    margin-right: 20px;
    &:last-child{
      margin-right: 0;
    }
  }
`;

class PageHeader extends Component {
    render() {
        return (
            <div className={this.props.className}>
                <Background/>
                <Content className={'container'}>
                    <HeaderBlock>
                        <Header>
                            <H size={1} styleSize={1}>
                                {this.props.title}
                            </H>
                        </Header>
                        <Subheader>
                            {this.props.subtitle}
                        </Subheader>
                    </HeaderBlock>
                    { this.props.actions ? <Actions>
                        {this.props.actions}
                    </Actions> : ''}
                </Content>
            </div>
        )
    }
}

export default styled(PageHeader)`
  min-height: 300px;
  padding-top: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;